import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Price.scss';

const Price = ({ price, soldOut = false, cart = false }) => {
	const isOnSale = price.showAsOnSale || price.priceAsNumber !== price.priceBeforeDiscountAsNumber;
	const discount = price.discountPercent || (100 - Math.round((price.priceAsNumber / price.priceBeforeDiscountAsNumber) * 100));
	return (
		soldOut ? (
			<span className={s.price}>{ soldOut }</span>
		) : (
			<span className={[s.price, (cart ? s.price__cart : null)].join(' ')}>{ isOnSale ? <s>{ price.priceBeforeDiscount }{ cart && <br /> }</s> : price.price } { isOnSale ? <span className={s.price_sale}>{`${price.price} -${discount}%`}</span> : null }</span>
		)
	);
};

export default hot(module)(Price);
